/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Login_ErrorInputs */



/**
* | output |
* | --- |
* | "Sign-in failed. Please try again." |
*
* @param {Partner_Login_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_login_error = /** @type {((inputs?: Partner_Login_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Login_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldung fehlgeschlagen. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Sign-in failed. Please try again.")
});